import React, { useState, useEffect } from "react";

import { getHemisphereDeficitBreakdown } from "../../../api/TBIRequests";

import HemisphericSum from "./HemisphericSum";

const HemisphericSumContainer = ({ patientId }) => {
  const [breakdown, setBreakdown] = useState([]);

  useEffect(() => {
    const fetchHemisphereDeficitBreakdown = async () => {
      try {
        const res = await getHemisphereDeficitBreakdown({ patientId });
        setBreakdown(res.data);
      } catch (err) {
        console.error("Error fetching hemisphere deficit breakdown", err);
      }
    };

    fetchHemisphereDeficitBreakdown();
  }, [patientId]);

  return <HemisphericSum hemisphereDeficitBreakdown={breakdown} />;
};
export default HemisphericSumContainer;
